import HttpClientXml from "../utils/HttpClientXml";

const getDonutChartData = async (data) => {
  return HttpClientXml.post("total-view-performance", data);
};

const getRevenueChartData = async (data) => {
  return HttpClientXml.post("total-view-revenue", data);
};

const getCompareData = async (data) => {
  return HttpClientXml.post("total-past-two-month-view", data);
};

const getSalesTransactionData = async (data) => {
  return HttpClientXml.post("total-sales-view", data);
};

export default {
  getSalesTransactionData,
  getCompareData,
  getRevenueChartData,
  getDonutChartData,
};
